import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { io } from 'socket.io-client';
import { fraseMateria } from './LeiturasSecretario'; // PLENARIUM:FRASE_MATERIA
import { Plus, Pencil, Trash2, X, ChevronUp, ChevronDown, Megaphone, Tv, Check } from 'lucide-react';

// =====================================================================
// PLENARIUM:LEITURAS -- secao "Expediente" na tela da sessao (admin).
// O admin cadastra o que o Secretario vai ler: materia apresentada (do
// Tramite ou digitada), aviso, convite, oficio, comunicado. O tablet do
// 1o/2o Secretario recebe na hora. Mostra tambem o que esta na TV.
// =====================================================================

// PLENARIUM:EXPEDIENTE_JUSTIFICATIVAS -- a ata anterior fica no passo 1 do Secretario; aqui so o Expediente
const TIPOS = [['MATERIA', 'Matéria apresentada'], ['COMUNICADO', 'Comunicado'], ['CONVITE', 'Convite'], ['JUSTIFICATIVA', 'Justificativa de ausência'], ['AVISO', 'Aviso'], ['OFICIO', 'Ofício'], ['OUTRO', 'Outro']];
const ROTULO = Object.fromEntries(TIPOS);
// PLENARIUM:EXPEDIENTE_VISUAL -- cor de cada tipo (a mesma do tablet do Secretario)
const COR_TIPO = { MATERIA: ['#1d4ed8', 'rgba(29,78,216,.12)'], COMUNICADO: ['#be185d', 'rgba(190,24,93,.12)'], CONVITE: ['#7c3aed', 'rgba(124,58,237,.12)'], JUSTIFICATIVA: ['#c2410c', 'rgba(194,65,12,.12)'], AVISO: ['#b45309', 'rgba(180,83,9,.12)'], OFICIO: ['#0f766e', 'rgba(15,118,110,.12)'], OUTRO: ['#475569', 'rgba(71,85,105,.12)'] };
const CSS_EXP = `
.exv-topo { display: flex; align-items: flex-start; gap: 12px; margin-bottom: 12px; }
.exv-ic { width: 40px; height: 40px; border-radius: 12px; background: rgba(37,99,235,.12); color: var(--acento, #2563eb); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.exv-h { font-size: 1rem; font-weight: 800; margin: 0; color: var(--texto); }
.exv-h span { font-weight: 600; color: var(--texto-suave); }
.exv-sub { font-size: .74rem; color: var(--texto-suave); margin: 3px 0 0; line-height: 1.45; max-width: 900px; }
.exv-prog { margin-bottom: 12px; }
.exv-prog-txt { display: flex; justify-content: space-between; align-items: center; font-size: .8rem; color: var(--texto-suave); margin-bottom: 5px; }
.exv-prog-txt b { color: var(--texto); }
.exv-ok { display: inline-flex; align-items: center; gap: 4px; color: #15803d; font-weight: 700; }
.exv-barra { height: 7px; border-radius: 999px; background: var(--cinza); overflow: hidden; }
.exv-barra span { display: block; height: 100%; background: var(--aprovado); border-radius: 999px; transition: width .4s; }
.exv-tv { display: flex; align-items: center; gap: 12px; padding: 12px 16px; margin-bottom: 12px; border-radius: 12px; color: #fff; background: linear-gradient(135deg, #0f2a5f, #1e3a8a); box-shadow: 0 6px 18px rgba(15,42,95,.25); }
.exv-tv-ic { width: 36px; height: 36px; border-radius: 10px; background: rgba(255,255,255,.12); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.exv-tv-rot { font-size: .68rem; font-weight: 800; letter-spacing: 1.4px; color: #93c5fd; }
.exv-tv-tit { font-weight: 700; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.exv-item { padding: 0 !important; overflow: hidden; border-left: 4px solid var(--cinza); transition: box-shadow .15s; }
.exv-item:hover { box-shadow: 0 6px 18px rgba(15,23,42,.08); }
.exv-linha { display: flex; align-items: flex-start; gap: 14px; padding: 14px 18px 12px; }
.exv-mover { display: flex; flex-direction: column; gap: 3px; flex-shrink: 0; margin-top: 2px; }
.exv-mover button { background: none; border: 1px solid var(--cinza); border-radius: 6px; padding: 1px 4px; cursor: pointer; color: var(--texto-suave); line-height: 0; }
.exv-mover button:disabled { opacity: .3; cursor: not-allowed; }
.exv-ordem { width: 40px; height: 40px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: .9rem; flex-shrink: 0; font-variant-numeric: tabular-nums; }
.exv-corpo { flex: 1; min-width: 0; }
.exv-meta { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; font-size: .72rem; margin-bottom: 3px; }
.exv-tipo { font-weight: 800; text-transform: uppercase; letter-spacing: .6px; }
.exv-tag { display: inline-flex; align-items: center; gap: 4px; border: 1px solid var(--cinza); border-radius: 999px; padding: 1px 8px; font-weight: 600; color: var(--texto-suave); }
.exv-tag.tv { border-color: #1e3a8a; color: #fff; background: #1e3a8a; }
.exv-tit { font-weight: 700; font-size: .93rem; line-height: 1.4; color: var(--texto); margin: 0; overflow-wrap: anywhere; }
.exv-txt { font-size: .8rem; color: var(--texto-suave); margin: 4px 0 0; line-height: 1.5; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.exv-item.lido .exv-tit { color: var(--texto-suave); }
.exv-status { border-radius: 999px; padding: 5px 12px; font-size: .74rem; font-weight: 800; white-space: nowrap; flex-shrink: 0; }
.exv-acoes { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; padding: 8px 18px; border-top: 1px solid var(--cinza); background: var(--cinza-claro, rgba(148,163,184,.06)); }
.exv-quando { display: inline-flex; align-items: center; gap: 5px; font-size: .74rem; color: var(--texto-suave); }
.exv-link { display: inline-flex; align-items: center; gap: 5px; background: none; border: none; padding: 5px 8px; border-radius: 8px; font: inherit; font-size: .78rem; font-weight: 600; color: var(--texto-suave); cursor: pointer; }
.exv-link:hover { background: var(--cinza); color: var(--texto); }
.exv-link.perigo:hover { color: var(--reprovado); }
@media (max-width: 640px) { .exv-linha { flex-wrap: wrap; } .exv-topo { flex-wrap: wrap; } }
`;
const TIPO_PROJ = { PROJETO_LEI: 'Projeto de Lei', PROJETO_RESOLUCAO: 'Projeto de Resolução', PROJETO_DECRETO: 'Projeto de Decreto', REQUERIMENTO: 'Requerimento', MOCAO: 'Moção', INDICACAO: 'Indicação', OUTROS: 'Outros', ATA_ANTERIOR: 'Ata' };
const VAZIO = { tipo: 'MATERIA', titulo: '', texto: '', projetoId: '' };

// PLENARIUM:EXPEDIENTE_NUMERO -- o numero do projeto ja vem como "PL 001/2026":
// tira a sigla (o tipo ja esta escrito por extenso) e so poe o ano se faltar.
const numeroMateria = (p) => { const n = String(p.numero || '').replace(/^[A-Za-z\u00c0-\u00ff]+\.?\s+/, '').trim(); return n.includes('/') ? n : `${n}/${p.ano}`; };

export default function ExpedienteAdmin({ sessaoId, sessaoStatus, projetos = [] }) {
  const [itens, setItens] = useState([]);
  const [naTV, setNaTV] = useState(null);
  const [modal, setModal] = useState(null); // { ...form, id? }
  const [salvando, setSalvando] = useState(false);
  // PLENARIUM:FRASE_MATERIA -- vereadores (sexo) para "do Vereador" / "da Vereadora"
  const [vereadoresF, setVereadoresF] = useState([]);
  useEffect(() => { axios.get('/api/vereadores').then(r => setVereadoresF(Array.isArray(r.data) ? r.data : [])).catch(() => {}); }, []);

  const carregar = useCallback(() => {
    axios.get(`/api/leituras/sessao/${sessaoId}/expediente`).then(r => setItens(Array.isArray(r.data) ? r.data : [])).catch(() => {});
    axios.get(`/api/leituras/sessao/${sessaoId}/atual`).then(r => setNaTV(r.data || null)).catch(() => {});
  }, [sessaoId]);

  useEffect(() => {
    carregar();
    const socket = io(process.env.REACT_APP_API_URL || 'http://localhost:3001');
    socket.on('connect', () => { socket.emit('entrar-sala', `sessao-${sessaoId}`); carregar(); });
    socket.on('expediente-atualizado', (d) => { if (!d || d.sessaoId === sessaoId) carregar(); });
    socket.on('leitura-atual', (d) => { if (d && d.sessaoId === sessaoId) setNaTV(d.leitura || null); });
    return () => socket.disconnect();
  }, [sessaoId, carregar]);

  const escolherProjeto = (pid) => {
    const p = projetos.find(x => x.id === pid);
    if (!p) { setModal(m => ({ ...m, projetoId: '' })); return; }
    setModal(m => ({
      ...m, projetoId: pid,
      titulo: fraseMateria({ tipo: TIPO_PROJ[p.tipo] || 'Matéria', numero: numeroMateria(p), autor: p.autor, ementa: p.ementa }, vereadoresF), // PLENARIUM:FRASE_MATERIA
      texto: m.texto || p.descricao || ''
    }));
  };

  const salvar = async (e) => {
    e.preventDefault();
    if (!modal.titulo.trim()) { toast.error('Informe o título.'); return; }
    setSalvando(true);
    try {
      const corpo = { tipo: modal.tipo, titulo: modal.titulo, texto: modal.texto, projetoId: modal.tipo === 'MATERIA' ? (modal.projetoId || null) : null };
      if (modal.id) await axios.put(`/api/leituras/expediente/${modal.id}`, corpo);
      else await axios.post(`/api/leituras/sessao/${sessaoId}/expediente`, corpo);
      toast.success('Item salvo!'); setModal(null); carregar();
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao salvar'); }
    finally { setSalvando(false); }
  };

  const remover = async (it) => {
    if (!window.confirm(`Remover do Expediente: "${it.titulo}"?`)) return;
    try { await axios.delete(`/api/leituras/expediente/${it.id}`); carregar(); } catch { toast.error('Erro ao remover'); }
  };

  const mover = async (i, dir) => {
    const j = i + dir; if (j < 0 || j >= itens.length) return;
    const nova = [...itens]; [nova[i], nova[j]] = [nova[j], nova[i]];
    setItens(nova);
    try { await axios.patch(`/api/leituras/sessao/${sessaoId}/expediente/ordem`, { ids: nova.map(x => x.id) }); } catch { toast.error('Erro ao reordenar'); carregar(); }
  };

  const alternarLido = async (it) => {
    try { await axios.patch(`/api/leituras/expediente/${it.id}/lido`, { lido: !it.lidoEm }); carregar(); } catch { toast.error('Erro ao marcar'); }
  };

  const tirarDaTV = async () => {
    try { await axios.post(`/api/leituras/sessao/${sessaoId}/atual`, { limpar: true }); setNaTV(null); } catch { toast.error('Erro ao tirar da TV'); }
  };

  const editavel = sessaoStatus !== 'ENCERRADA';
  const lidos = itens.filter(x => x.lidoEm).length;
  // PLENARIUM:EXPEDIENTE_CONCLUIDO -- avisa o admin quando o Secretario termina a leitura
  const lidosAntesRef = React.useRef(null);
  useEffect(() => {
    const antes = lidosAntesRef.current; lidosAntesRef.current = lidos;
    if (antes !== null && itens.length > 0 && lidos === itens.length && antes < itens.length && sessaoStatus === 'EM_ANDAMENTO') toast.success('O Secretário concluiu a leitura do Expediente.', { duration: 6000 });
  }, [lidos, itens.length, sessaoStatus]);

  return (
    <div style={{ marginBottom: 24 }}>
      <style>{CSS_EXP}</style>{/* PLENARIUM:EXPEDIENTE_VISUAL */}
      <div className="exv-topo">
        <div className="exv-ic"><Megaphone size={20} /></div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <h2 className="exv-h">Expediente <span>· leituras do Secretário</span></h2>
          <p className="exv-sub">Matérias apresentadas, comunicados, convites, justificativas de ausência, avisos e ofícios. Aparecem na hora no tablet do 1º e do 2º Secretário; as justificativas recebidas desde a sessão anterior entram sozinhas (sem o motivo).</p>
        </div>
        {editavel && <button className="btn btn-primary btn-sm" onClick={() => setModal({ ...VAZIO })}><Plus size={13} /> Adicionar item</button>}
      </div>

      {itens.length > 0 && (
        <div className="exv-prog">
          <div className="exv-prog-txt"><span><b>{lidos}</b> de {itens.length} lido{itens.length > 1 ? 's' : ''}</span>{lidos === itens.length && <span className="exv-ok"><Check size={12} /> Expediente concluído</span>}</div>
          <div className="exv-barra"><span style={{ width: `${Math.round((lidos / itens.length) * 100)}%` }} /></div>
        </div>
      )}
      {itens.length > 0 && lidos === itens.length && sessaoStatus === 'EM_ANDAMENTO' && ( // PLENARIUM:EXPEDIENTE_CONCLUIDO
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderRadius: 12, background: '#ecfdf5', border: '1px solid #86efac', color: '#14532d', margin: '10px 0' }}>
          <span style={{ width: 34, height: 34, borderRadius: '50%', background: '#16a34a', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Check size={18} /></span>
          <div><b>Leitura do Expediente concluída.</b> <span style={{ color: '#166534' }}>Próximo passo: Uso da Tribuna.</span></div>
        </div>
      )}

      {naTV && (
        <div className="exv-tv">
          <span className="exv-tv-ic"><Tv size={18} /></span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="exv-tv-rot">NA TV AGORA{naTV.leitor ? ` · LEITURA: ${naTV.leitor.toUpperCase()}` : ''}</div>
            <div className="exv-tv-tit">{naTV.titulo}</div>
          </div>
          <button className="btn btn-secondary btn-sm" onClick={tirarDaTV}><X size={13} /> Tirar da TV</button>
        </div>
      )}

      {itens.length === 0 ? (
        <div className="card sem-dados"><p>Nenhum item no Expediente.</p></div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {itens.map((it, i) => {
            const [cor, fundo] = COR_TIPO[it.tipo] || COR_TIPO.OUTRO;
            const lido = !!it.lidoEm;
            const naTela = naTV && naTV.chave === 'item:' + it.id;
            return (
              <div key={it.id} className={`card exv-item ${lido ? 'lido' : ''}`} style={{ borderLeftColor: lido ? 'var(--aprovado)' : cor }}>
                <div className="exv-linha">
                  {editavel && (
                    <div className="exv-mover">
                      <button onClick={() => mover(i, -1)} disabled={i === 0} title="Subir"><ChevronUp size={14} /></button>
                      <button onClick={() => mover(i, 1)} disabled={i === itens.length - 1} title="Descer"><ChevronDown size={14} /></button>
                    </div>
                  )}
                  <div className="exv-ordem" style={lido ? { background: 'rgba(22,163,74,.13)', color: '#15803d' } : { background: fundo, color: cor }}>{lido ? <Check size={18} /> : String(i + 1).padStart(2, '0')}</div>
                  <div className="exv-corpo">
                    <div className="exv-meta">
                      <span className="exv-tipo" style={{ color: cor }}>{ROTULO[it.tipo] || it.tipo}</span>
                      {it.projetoId && <span className="exv-tag">Matéria no Trâmite</span>}
                      {naTela && <span className="exv-tag tv"><Tv size={11} /> Na TV</span>}
                    </div>
                    <p className="exv-tit">{it.titulo}</p>
                    {it.texto && <p className="exv-txt">{it.texto}</p>}
                  </div>
                  <span className="exv-status" style={lido ? { color: '#15803d', background: 'rgba(22,163,74,.13)' } : { color: '#b45309', background: 'rgba(217,119,6,.13)' }}>{lido ? 'Lido' : 'A ler'}</span>
                </div>
                <div className="exv-acoes">
                  {lido
                    ? <span className="exv-quando"><Check size={12} /> Lido{it.lidoEm ? ` às ${new Date(it.lidoEm).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}` : ''}{it.lidoPor ? ` · ${it.lidoPor}` : ''}</span>
                    : <span className="exv-quando">Aguardando a leitura do Secretário</span>}
                  <span style={{ flex: 1 }} />
                  <button className="exv-link" onClick={() => alternarLido(it)}><Check size={13} /> {lido ? 'Desmarcar leitura' : 'Marcar como lido'}</button>
                  {editavel && <button className="exv-link" onClick={() => setModal({ id: it.id, tipo: it.tipo, titulo: it.titulo, texto: it.texto || '', projetoId: it.projetoId || '' })}><Pencil size={13} /> Editar</button>}
                  {editavel && <button className="exv-link perigo" onClick={() => remover(it)}><Trash2 size={13} /> Remover</button>}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {modal && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 620 }}>
            <div className="modal-header">
              <h2 className="modal-title">{modal.id ? 'Editar item do Expediente' : 'Novo item do Expediente'}</h2>
              <button className="btn-modal-close" onClick={() => setModal(null)}><X size={18} /></button>
            </div>
            <form onSubmit={salvar}>
              <div className="form-group">
                <label className="form-label">Tipo</label>
                <select className="form-input form-select" value={modal.tipo} onChange={e => setModal({ ...modal, tipo: e.target.value })}>
                  {TIPOS.map(([v, r]) => <option key={v} value={v}>{r}</option>)}
                </select>
              </div>
              {modal.tipo === 'MATERIA' && (
                <div className="form-group">
                  <label className="form-label">Matéria do Trâmite (opcional)</label>
                  <select className="form-input form-select" value={modal.projetoId} onChange={e => escolherProjeto(e.target.value)}>
                    <option value="">— Digitar sem vincular —</option>
                    {projetos.filter(p => p.tipo !== 'ATA_ANTERIOR').map(p => <option key={p.id} value={p.id}>{(TIPO_PROJ[p.tipo] || p.tipo)} {p.numero}/{p.ano} — {String(p.ementa || '').slice(0, 80)}</option>)}
                  </select>
                  <p style={{ fontSize: '0.7rem', color: 'var(--texto-suave)', marginTop: 4 }}>Vinculando, o Secretário também pode abrir os documentos da matéria.</p>
                </div>
              )}
              <div className="form-group">
                <label className="form-label">Título *</label>
                <textarea className="form-input" rows={2} value={modal.titulo} onChange={e => setModal({ ...modal, titulo: e.target.value })} placeholder={modal.tipo === 'CONVITE' ? 'Ex.: Convite da Secretaria de Educação para a feira escolar' : 'O que o Secretário vai anunciar'} required />
              </div>
              <div className="form-group">
                <label className="form-label">Texto para leitura</label>
                <textarea className="form-input" rows={7} value={modal.texto} onChange={e => setModal({ ...modal, texto: e.target.value })} placeholder="Texto completo que o Secretário lê em voz alta (opcional)" />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setModal(null)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
